module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-mobile-822x134.1a36c933.jpg";